import React from 'react'
import Link from 'next/link'
import { MenuLink as ReachMenuLink } from '@reach/menu-button'

import Stack from '@careguide/stack'
import { Badge } from '@careguide/badge'

import { HeaderLink } from '../HeaderLink'
import styled from 'styled-components'

export type NavMobileLoggedInProps = {
  topNavItems: any[]
  bottomNavItems: any[]
  unreadMessageCount: number
}

export const NavMobileLoggedIn = ({
  topNavItems,
  bottomNavItems,
  unreadMessageCount,
}: NavMobileLoggedInProps) => (
  <>
    <Stack gap='4' align='center'>
      {topNavItems.map((item: any, index) => (
        <MobileMenuLink key={index} item={item} unreadMessageCount={unreadMessageCount} />
      ))}
    </Stack>

    <Stack gap='4' align='center'>
      {bottomNavItems.map((item, index) => (
        <MobileMenuLink key={index} item={item} />
      ))}
    </Stack>
  </>
)

const MobileMenuLink = ({ item, unreadMessageCount = 0 }) =>
  item.isNextLink ? (
    <MenuLink as={InternalLink as any} href={item.link}>
      {item.title}
      {item.isInbox && unreadMessageCount > 0 && (
        <Badge size='small' variant='sponsored'>
          {unreadMessageCount}
        </Badge>
      )}
    </MenuLink>
  ) : (
    <MenuLink as={HeaderLink} href={item.link}>
      {item.title}
      {item.isInbox && unreadMessageCount > 0 && (
        <Badge size='small' variant='sponsored'>
          {unreadMessageCount}
        </Badge>
      )}
    </MenuLink>
  )

const InternalLink = React.forwardRef<any, any>(({ href, ...props }, ref) => {
  return (
    <Link href={href} passHref>
      <HeaderLink {...props} />
    </Link>
  )
})

const MenuLink = styled(ReachMenuLink)`
  > ${Badge} {
    margin-left: 5px;
  }
`
